/* Club Blackdog — mantiene el 4% y los puntos al dia. 05/10/2026 */
(function () {
  function fmtUSD(cents) {
    var e = Math.floor(cents / 100), d = cents % 100;
    return 'USD ' + e + ',' + (d < 10 ? '0' + d : d);
  }
  function puntosLabel(cents) {
    var n = Math.floor(cents / 1000);
    return n + ' ' + (n === 1 ? 'punto' : 'puntos');
  }
  function pintar(el, baseCents) {
    var m = el.querySelector('.bd-monto');
    if (m) m.textContent = fmtUSD(Math.round(baseCents * 0.04));
    var p = el.querySelector('.bd-puntos');
    if (p) p.textContent = puntosLabel(baseCents);
  }

  /* ---------- FICHA DE PRODUCTO: sigue al selector de cantidad ---------- */
  function findQtyInput(el) {
    var node = el;
    while (node) {
      if (node.querySelector) {
        var i = node.querySelector('.quantity__input');
        if (i) return i;
      }
      node = node.parentElement;
    }
    return null;
  }
  function wireProducto(el) {
    var unit = parseInt(el.getAttribute('data-bd-unit') || '0', 10);
    if (!unit) return;
    var input = findQtyInput(el);
    if (!input) return;
    function upd() {
      var q = parseInt(input.value, 10);
      if (!q || q < 1) q = 1;
      pintar(el, unit * q);
    }
    input.addEventListener('change', upd);
    input.addEventListener('input', upd);
    upd();
  }
  function initProducto() {
    var nodes = document.querySelectorAll('.bd-club-js');
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].__bdWired) { nodes[i].__bdWired = true; wireProducto(nodes[i]); }
    }
  }

  /* ---------- CARRITO: el bloque va a lo ancho, fuera de .js-contents ----------
     Shopify solo vuelve a dibujar .js-contents cuando cambia una cantidad, asi que
     este bloque no se actualiza solo: le preguntamos el total a /cart.js.          */
  function initCarrito() {
    var el = document.querySelector('.bd-club--carrito');
    var host = document.getElementById('main-cart-footer');
    if (!el || !host || host.__bdWired) return;
    host.__bdWired = true;

    var pendiente = null;
    function refrescar() {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (!c || typeof c.total_price !== 'number') return;
          if (c.item_count === 0) { el.style.display = 'none'; return; }
          el.style.display = '';
          pintar(el, c.total_price);
        })
        .catch(function () { /* si falla, se queda con el numero que ya tenia */ });
    }
    new MutationObserver(function () {
      if (pendiente) clearTimeout(pendiente);
      pendiente = setTimeout(function () { pendiente = null; refrescar(); }, 260);
    }).observe(host, { childList: true, subtree: true, characterData: true });
  }

  function init() { initProducto(); initCarrito(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  /* Dawn vuelve a dibujar la ficha al cambiar de variante: hay que re-enganchar. */
  var t = null;
  new MutationObserver(function () {
    if (t) return;
    t = setTimeout(function () { t = null; init(); }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
